export default __webpack_public_path__ + "static/media/model-3-range-map.538973cb.png";